class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    // Create a renderProductCount event
    var event;
    if (typeof(window.CustomEvent) === 'function') {
      event = new CustomEvent('renderProductCount', {
        bubbles: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('renderProductCount', true, false, null);
    }
    
    // Dispatch the render event
    document.dispatchEvent(event); 
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    
    facetsToRender.forEach((element) => {
     // console.log(element.innerHTML);
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.price-input input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    //this.setMinAndMaxValues();
    //console.log("TTT");
    this.priceRange();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
     this.setMinAndMaxValues();
    this.priceRange();
  }

  setMinAndMaxValues() {
    const inputs = document.querySelectorAll('#FacetsWrapperDesktop .price-input input');
    const inputsM = document.querySelectorAll('#FacetFiltersFormMobile .price-input input');
    const inputsRD = document.querySelectorAll('#FacetsWrapperDesktop .range-input input');
    const inputsRM = document.querySelectorAll('#FacetFiltersFormMobile .range-input input');
    
    const rangeD = document.querySelector("#FacetsWrapperDesktop .sliderprice .progressprice");
    const rangeM = document.querySelector("#FacetFiltersFormMobile .sliderprice .progressprice");
    
   // console.log(inputs);
    if(inputs.length){
        const minInput = inputs[0];
        const maxInput = inputs[1];
        
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
        
        if(minInput.value != ''){
          inputsRD[0].value = minInput.value;
          rangeD.style.left = ((minInput.value / inputsRD[0].max) * 100) + "%";
        }
        if(maxInput.value != ''){
          inputsRD[1].value = maxInput.value;
          rangeD.style.right = 100 - (maxInput.value / inputsRD[1].max) * 100 + "%";
        }
    }
    
    if(inputsM.length){
    
        const minInputM = inputsM[0];
        const maxInputM = inputsM[1];
        if (maxInputM.value) minInputM.setAttribute('max', maxInputM.value);
        if (minInputM.value) maxInputM.setAttribute('min', minInputM.value);
        if (minInputM.value === '') maxInputM.setAttribute('min', 0);
        if (maxInputM.value === '') minInputM.setAttribute('max', maxInputM.getAttribute('max'));

          if(minInputM.value != ''){
            inputsRM[0].value = minInputM.value;
            rangeM.style.left = ((minInputM.value / inputsRM[0].max) * 100) + "%";
          }
          if(maxInputM.value != ''){  
            inputsRM[1].value = maxInputM.value;
            rangeM.style.right = 100 - (maxInputM.value / inputsRM[1].max) * 100 + "%";
          }
    }  
  }
  
  
  priceRange(){
    const rangeInputD = document.querySelectorAll("#FacetsWrapperDesktop .range-input input"),
          priceInputD = document.querySelectorAll("#FacetsWrapperDesktop .price-input input"),
          rangeD = document.querySelector("#FacetsWrapperDesktop .sliderprice .progressprice"),
    	 rangeInputM = document.querySelectorAll("#FacetFiltersFormMobile .range-input input"),
          priceInputM = document.querySelectorAll("#FacetFiltersFormMobile .price-input input"),
          rangeM = document.querySelector("#FacetFiltersFormMobile .sliderprice .progressprice");
    let priceGap = 0;
//console.log(rangeInput);
    priceInputD.forEach(input =>{
      input.addEventListener("input", e =>{
       // console.log(e.target.closest('.price-input'));
        let minPriceD = parseInt(priceInputD[0].value),
            maxPriceD = parseInt(priceInputD[1].value);

        if((maxPriceD - minPriceD >= priceGap) && maxPriceD <= rangeInputD[1].max){
        // console.log(e.target.className);

          if(e.target.classList.contains("input-min")){
            rangeInputD[0].value = minPriceD;
            rangeD.style.left = ((minPriceD / rangeInputD[0].max) * 100) + "%";
          }else{
            rangeInputD[1].value = maxPriceD;
            rangeD.style.right = 100 - (maxPriceD / rangeInputD[1].max) * 100 + "%";
          }
        }
      });
    });

    rangeInputD.forEach(input =>{
      input.addEventListener("input", e =>{
        let minValD = parseInt(rangeInputD[0].value),
            maxValD = parseInt(rangeInputD[1].value);

        if((maxValD - minValD) < priceGap){
          if(e.target.classList.contains("range-min")){
            rangeInputD[0].value = maxValD - priceGap
          }else{
            rangeInputD[1].value = minValD + priceGap;
          }
        }else{
          priceInputD[0].value = minValD;
          priceInputD[1].value = maxValD;
          rangeD.style.left = ((minValD / rangeInputD[0].max) * 100) + "%";
          rangeD.style.right = 100 - (maxValD / rangeInputD[1].max) * 100 + "%";
        }
      });
    });
    
    priceInputM.forEach(input =>{
      input.addEventListener("input", e =>{
      //  console.log(e.target.closest('.price-input'));
        let minPriceM = parseInt(priceInputM[0].value),
            maxPriceM = parseInt(priceInputM[1].value);

        if((maxPriceM - minPriceM >= priceGap) && maxPriceM <= rangeInputM[1].max){
       //  console.log(e.target.className);

          if(e.target.classList.contains("input-min")){
            rangeInputM[0].value = minPriceM;
            rangeM.style.left = ((minPriceM / rangeInputM[0].max) * 100) + "%";
          }else{
            rangeInputM[1].value = maxPriceM;
            rangeM.style.right = 100 - (maxPriceM / rangeInputM[1].max) * 100 + "%";
          }
        }
      });
    });

    rangeInputM.forEach(input =>{
      input.addEventListener("input", e =>{
        let minValM = parseInt(rangeInputM[0].value),
            maxValM = parseInt(rangeInputM[1].value);

        if((maxValM - minValM) < priceGap){
          if(e.target.classList.contains("range-min")){
            rangeInputM[0].value = maxValM - priceGap
          }else{
            rangeInputM[1].value = minValM + priceGap;
          }
        }else{
          priceInputM[0].value = minValM;
          priceInputM[1].value = maxValM;
          rangeM.style.left = ((minValM / rangeInputM[0].max) * 100) + "%";
          rangeM.style.right = 100 - (maxValM / rangeInputM[1].max) * 100 + "%";
        }
      });
    });

  }
  
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
